import { ProgressBarBand } from "@app/shared/progressBarBand";
import { Component } from "react";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";

interface AccuracyTooltipLegendProps {
  inspectionName: string;
  progressBarBands: ProgressBarBand[];
}

export default class AccuracyTooltipLegend extends Component<AccuracyTooltipLegendProps> {
  public render() {
    return (
      <div className="accuracy-tooltip-legend">
        <div>
          {this.props.inspectionName}
        </div>
        <hr />
        <table className="table table-borderless">
          <tbody>
            {this.props.progressBarBands.map((a, index) => {
              return (
                <tr className="text-white" key={index}>
                  <td className="px-1 py-0">
                    <QesIcon
                      iconName={QesIcons.Circle}
                      pathStyle={{ fill: a.color, stroke: "none" }}
                      isDecorative
                      className="cursor-pointer align-text-top"
                    />
                  </td>
                  <td className="px-1 py-0 text-end">
                    {a.outOfScale ? "<0.1" : a.percent.toFixed(1)}%
                  </td>
                  <td className="px-1 py-0">
                    {a.tooltip}
                  </td>
                  {this.props.progressBarBands.some(band => band.justification) &&
                    <td className="px-1 py-0">
                    {a.justification && a.justification}
                    </td>
                  }                  
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}
